const features = [
  {
    icon: "ri-dashboard-3-line",
    title: "一站总览",
    desc: "把本月散落在各个平台的热点集中到一处，打开即看全局，无需来回切换十几个账号。",
  },
  {
    icon: "ri-anticlockwise-2-line",
    title: "每 6 小时刷新",
    desc: "榜单与分类数据定时自动更新，突发事件即时补录，帮你始终踩在最新节奏上。",
  },
  {
    icon: "ri-shield-check-line",
    title: "多方核验",
    desc: "优先采用官方公告与交叉信源，多方说法并列呈现，吃瓜不偏听、不站队。",
  },
  {
    icon: "ri-folders-line",
    title: "全记录归档",
    desc: "时间轴完整还原本月关键节点，哪怕中途没跟进，也能顺着脉络把来龙去脉补上。",
  },
];

export default function Overview() {
  return (
    <section id="overview" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-800">
              <i className="ri-scan-2-line"></i> 本月大瓜总览
            </span>
            <h2 className="font-heading text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
              为什么选择<span className="text-primary-600">本月大瓜</span>
              <br />
              当作你的吃瓜入口？
            </h2>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
              追热点最怕"后知后觉"。我们把本月娱乐圈与公众关注的热门事件，按热度、领域和发生时间三个维度做了一次系统盘点——
              既有横向的实时比拼，也有纵向的深度脉络，让你花最少的时间，get 到最全的瓜。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {["影视剧", "综艺", "音乐", "商业", "体坛"].map((t) => (
                <span
                  key={t}
                  className="cursor-pointer whitespace-nowrap rounded-full bg-secondary-100 px-4 py-1.5 text-xs font-semibold text-secondary-900 transition hover:bg-secondary-200"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {features.map((f, i) => (
              <article
                key={f.title}
                className="rounded-2xl border border-background-200 bg-background-100/60 p-5 transition hover:-translate-y-1 hover:bg-background-100"
              >
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-xl text-background-50 ${
                    i % 2 === 0 ? "bg-primary-500" : "bg-accent-500"
                  }`}
                >
                  <i className={`${f.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{f.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{f.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}